<template>
  <div class="animated fadeIn liquidacion-sueldos-pago">
    <b-row>
      <b-col xl="12">
        <b-form>
          <b-card>
            <b-form-group
              label="Periodo"
              label-for="periodo"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="periodo" 
                v-model="periodoLiquidacion" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>
          </b-card>

          <b-card>
            <b-table 
                small 
                responsive="sm"
                class="registro" 
                :items="liquidacionesPersonal" 
                :fields="fields">

              <template v-slot:cell(personal)="data">
                <template v-if="data.item.facturaHonorarios">
                  {{ data.item.personal }} <span>(*)</span>
                </template>
                <template v-if="!data.item.facturaHonorarios">
                  {{ data.item.personal }}
                </template>
              </template>
              <template v-slot:cell(honorarios)="data">
                {{ data.item.honorarios | moneda }}
              </template>
              <template v-slot:cell(adicional)="data">
                {{ data.item.adicional | moneda }}
              </template>
              <template v-slot:cell(otrosConceptos)="data">
                {{ data.item.otrosConceptos | moneda }}
              </template>
              <template v-slot:cell(liquidacionFinal)="data">
                {{ data.item.liquidacionFinal | moneda }}
              </template>
              <template v-slot:cell(adelantos)="data">
                {{ data.item.adelantos | moneda }}
              </template>
              <template v-slot:cell(total)="data">
                {{ data.item.total | moneda }}
              </template>
              <template v-slot:cell(saldo)="data">
                {{ data.item.saldo | moneda }}
              </template>
              <template v-slot:cell(importe)="data">
                <template v-if="data.item.saldo != 0 && !data.item.facturaHonorarios">
                  <input type="number"
                      v-model.number="data.item.importe"
                      @focus="$event.target.select()"
                      @input="calcularTotales()"/>
                </template>
              </template>
            </b-table>

            <b-table 
                small 
                responsive="sm"
                class="registro totales" 
                :items="totales" 
                :fields="totalesFields">
              <template v-slot:cell(honorarios)="data">
                {{ data.item.honorarios | moneda }}
              </template>
              <template v-slot:cell(adicional)="data">
                {{ data.item.adicional | moneda }}
              </template>
              <template v-slot:cell(otrosConceptos)="data">
                {{ data.item.otrosConceptos | moneda }}
              </template>
              <template v-slot:cell(liquidacionFinal)="data">
                {{ data.item.liquidacionFinal | moneda }}
              </template>
              <template v-slot:cell(adelantos)="data">
                {{ data.item.adelantos | moneda }}
              </template>
              <template v-slot:cell(total)="data">
                {{ data.item.total | moneda }}
              </template>
              <template v-slot:cell(saldo)="data">
                {{ data.item.saldo | moneda }}
              </template>
              <template v-slot:cell(importe)="data">
                {{ data.item.importe | moneda }}
              </template>
            </b-table>
            <small class="text-muted">(*) Factura Honorarios</small>
          </b-card>
        </b-form>
      </b-col>  
    </b-row>
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'liquidacionSueldosPagos/getField',
  mutationType: 'liquidacionSueldosPagos/updateField',
});

export default {
  name: 'PagoPersonal',
  components: {
  },
  data () {
    return {
      fields: [
        { key: 'personal' },
        {
          key: 'honorarios',
          label: 'Sueldo',
          class: 'text-right'
        },
        {
          key: 'adicional',
          class: 'text-right'
        },
        {
          key: 'otrosConceptos',
          class: 'text-right'
        },
        {
          key: 'liquidacionFinal',
          class: 'text-right'
        },
        {
          key: 'adelantos',
          class: 'text-right'
        },
        {
          key: 'total',
          class: 'text-right'
        },
        {
          key: 'saldo',
          class: 'text-right'
        },
        {
          key: 'importe',
          class: 'text-right'
        },
      ],

      totalesFields: [
        { key: 'totales' },
        {
          key: 'honorarios',
          label: 'Sueldo',
          class: 'text-right'
        },
        {
          key: 'adicional',
          class: 'text-right'
        },
        {
          key: 'otrosConceptos',
          class: 'text-right'
        },
        {
          key: 'liquidacionFinal',
          class: 'text-right'
        },
        {
          key: 'adelantos',
          class: 'text-right'
        },
        {
          key: 'total',
          class: 'text-right'
        },
        {
          key: 'saldo',
          class: 'text-right'
        },
        {
          key: 'importe',
          class: 'text-right'
        },
      ],

      labelCols: 2
    }
  },
  computed: {
    ...mapFields([
      'periodo',
      'liquidacionesPersonal',
      'totalPagos',
      'total',
      'totalLiquidacion'
    ]),
    periodoLiquidacion() {
      if (this.periodo) {
        return this.$options.filters.periodo(this.periodo);
      }
      return '';
    },
    totales() {
      let totales = [];
      totales.push({
        totales: 'TOTALES',
        honorarios: this.total.honorarios,
        adicional: this.total.adicionales,
        otrosConceptos: this.total.otrosConceptos,
        liquidacionFinal: this.total.liquidacionesFinales,
        adelantos: this.total.adelantos,
        total: this.total.total,
        saldo: this.total.saldo,
        importe: this.totalLiquidacion
      })
      return totales;
    },
  },
  created() {
    
  },
  activated() {
    this.validarPago();
  },
  methods: {
    calcularTotales(item) {
      this.$store.dispatch('liquidacionSueldosPagos/calcularTotales');
      this.validarPago();
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }
    },
    validarPago() {
      this.$emit('can-continue', { value: false });

      if (this.totalPagos != 0) {
        this.$emit('can-continue', { value: true });
      }
    }
  },
  validations: {
  },  
  watch: {
  },
}
</script>

<style>
  .liquidacion-sueldos-pago .registro table thead th {
    border-top: none;
  }

  .liquidacion-sueldos-pago .registro table td {
    vertical-align: middle;
  }

  .liquidacion-sueldos-pago .registro table td {
    width: 10%;
  }
  .liquidacion-sueldos-pago .registro table td[aria-colindex="1"] {
    width: 20%;
  }

  .liquidacion-sueldos-pago .registro.totales table thead {
    display: none;
  }
  .liquidacion-sueldos-pago .registro.totales table tr td {
    border-top: none;
    font-weight: bold;
  }
</style>
